export default __webpack_public_path__ + "static/media/img-hf-3.511d4c82.png";